export enum ItemType {
  FOLDER = 'Folder',
  LIST = 'List',
  BREADCRUMB = 'Breadcrumb',
}

export interface Item {
  type: ItemType;
  payload: any;
  title?: string;
}
